import {login, getInfo, doGjgLoginEx, doGjgLogin} from '@/api/user'
import { getToken, setToken, removeToken, getCustomerToken, setCustomerToken, removeCustomerToken, removeProductLineToken } from '@/utils/auth'
import md5 from 'js-md5'
import { asyncRoutes } from '@/router'

const state = {
  token: getToken(),
  UserObj: {},
  CustomerToken: getCustomerToken(),
  ImgPath: 'https://img.appkingdee.com',
  roles: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_CUSTOMERTOKEN: (state, CustomerToken) => {
    state.CustomerToken = CustomerToken
  },
  SET_USEROBJ: (state, UserObj) => {
    state.UserObj = UserObj
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  }
}

const actions = {
  // user login
  doGjgLogin ({ commit }, External) {
    return new Promise((resolve, reject) => {
      doGjgLogin(External).then(response => {
        if (response.Code === 0) {
          commit('SET_TOKEN', response.Data.GUID)
          commit('SET_CUSTOMERTOKEN', response.Data.Token)
          setCustomerToken(response.Data.Token)
          setToken(response.Data.GUID)
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user login
  doGjgLoginEx ({ commit }, External) {
    return new Promise((resolve, reject) => {
      doGjgLoginEx(External).then(response => {
        if (response.Code === 0) {
          commit('SET_TOKEN', response.Data.GUID)
          commit('SET_CUSTOMERTOKEN', response.Data.Token)
          setCustomerToken(response.Data.Token)
          setToken(response.Data.GUID)
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user login
  login ({ commit }, userInfo) {
    const {username, password, LoginSource, verifycode} = userInfo
    return new Promise((resolve, reject) => {
      login({PhoneNumber: username.trim(), Password: md5(password), VerifyCode: verifycode, LoginSource: LoginSource}).then(response => {
        console.log(response)
        if (response.Code === 0) {
          commit('SET_TOKEN', response.Data.GUID)
          commit('SET_CUSTOMERTOKEN', response.Data.Token)
          setCustomerToken(response.Data.Token)
          setToken(response.Data.GUID)
        }
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // get user info
  getInfo ({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        if (!response.Code === 0) {
          reject(response.Message)
        } else {
          const data = response.Data
          commit('SET_USEROBJ', data)
          commit('SET_ROLES', asyncRoutes)
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout ({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      // logout(state.token).then(() => {
      commit('SET_TOKEN', '')
      commit('SET_CUSTOMERTOKEN', '')
      commit('SET_USEROBJ', {})
      removeToken()
      removeCustomerToken()
      removeProductLineToken()
      dispatch('tagsView/delAllViews', null, { root: true })
      commit('SET_ROLES', [])
      resolve()
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // remove token
  resetToken ({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_CUSTOMERTOKEN', '')
      commit('SET_USEROBJ', {})
      removeToken()
      removeCustomerToken()
      removeProductLineToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js